import { render, staticRenderFns } from "./MidwifeMasterdataDetail.vue?vue&type=template&id=924a4c70"
import script from "./MidwifeMasterdataDetail.vue?vue&type=script&lang=js"
export * from "./MidwifeMasterdataDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports